import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import LeftSideMenu from '../../../components/MenuManager/Left';
import Utils from '../../../utils';
import AuthUtils from '../../../utils/authentication';
import UserAgentUtils from '../../../utils/userAgent';
import { MenuItemType } from '../../../typings/menu';

const mapStateToProps = ({
	menuManager,
	authentication,
	appInfos,
	galleryInfos,
	galleryInfos: {
		config: galleryConfig
	},
	newDriveItems,
	driveList,
	profile,
}: StoreState) => {
	const privateDirId = Utils.getPrivateDirId(driveList, galleryConfig);
	const sharedDirId = Utils.getSharedDirId(driveList, galleryInfos);
	const { mode } = authentication.userInfos;
	const { menuModes, leftMenuIsOpen } = menuManager;
	const { burger } = menuModes;

	const isMultiApp = Utils.isMultiApp(appInfos);
	const isMobileApp = UserAgentUtils.isMobileApp;
	const isConnectedSingleApp = !isMultiApp && !AuthUtils.isSaml(mode) && AuthUtils.isConnected(mode);
	const isGalleryButtonNeeded = galleryInfos.isConfigLoaded && Utils.isTemplateLoaded(appInfos, galleryInfos) && galleryInfos.template.welcomepage;
	const newItemsNb = Object.keys(newDriveItems.items).length;
	const hasLogOutButton = isMobileApp && isConnectedSingleApp;
	const hasProfile = isMultiApp;
	const hasProposalStatsPage = isMultiApp && !!privateDirId;

	let filteredMenuItems = burger.filter(item => {
		switch (item.type) {
			case MenuItemType.Gallery:
				return isGalleryButtonNeeded;
			case MenuItemType.New:
				return UserAgentUtils.isOnline() || !Utils.isMaster(galleryInfos.config);
			case MenuItemType.Downloads:
				return isMobileApp;
			case MenuItemType.CreateButton:
				return isMultiApp && !!privateDirId;
			default:
				return item;
		}
	});

	return {
		isOpen: leftMenuIsOpen,
		newItemsNb,
		filteredMenuItems,
		hasLogOutButton,
		hasProfile,
		hasProposalStatsPage,
		privateDirId,
		sharedDirId,
		isProfileLoaded: hasProfile && !!profile.clientId,
	};
};

export default connect(mapStateToProps)(LeftSideMenu);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Left/index.tsx